module.exports = __webpack_public_path__ + "media/images/admin/icons/log-out-3d243e9f40434c5add5a1dc09b528bdf.svg";